import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useViewport } from '@/lib/hooks/use-viewport';
import { DAdminShell } from '@/components/organisms/admin-shell';
import { AdminDesktopOnlyNotice } from '@/components/organisms/admin-desktop-only-notice';
import { AdminOverviewBody } from '@/components/molecules/admin-overview-body';

function AdminIndex(): ReactElement {
  const viewport = useViewport();
  if (viewport !== 'desktop') return <AdminDesktopOnlyNotice />;
  return (
    <DAdminShell section="dashboard" title="Instance overview">
      <AdminOverviewBody />
    </DAdminShell>
  );
}

export const Route = createFileRoute('/admin/')({
  component: AdminIndex,
});
